<div class="mainBody">
    <div class="container-fluid loginContainer">
        <div class="col-md-12 mt-1">
            <img src="../../../assets/images/CanString AI logo.svg" class="CanString-AI-logo">
        </div>
        <div class="row mt-4">
            <div class="col-md-12 full-height-percentage">
           
            
                  <div class="d-flex flex-column justify-content-center align-items-center ">
                    <p style="font-size:1.5rem; text-align: center; color: grey; width:200px; height: 200px;">Page Not Found</p>
                     </div>
                
            </div>
        </div>
       
    </div>
</div>